import React, { useMemo, useState } from "react";
import { Actions } from "./index";
import { Link } from "react-router-dom";
import config from "constants/config";
import Pagination from "../../../../../components/pagination";

export const UpsellingIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.0013 6.66602L6.66797 9.99935" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 6.66602V13.3327" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.3333 9.99935L10 6.66602" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const MobileProducts = ({ data, currency, showConfirm }) => {

    let SIZE = 3;
    const [currentPage, setCurrentPage] = useState(1);
    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * SIZE;
        const lastPageIndex = firstPageIndex + SIZE;
        return data.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, data]);

    if(!data.length) {
        return null;
    }

    return (
        <div>
            {currentTableData.map((item, key) => {

                const { uniqid, title, products, discount_type, discount_amount } = item;

                return <div className="table-mobile-card" key={key}>

                    <div className="table-mobile-card-header">
                        <div className="d-flex">
                            <div className="table-mobile-card-header-icon">
                                <UpsellingIcon />
                            </div>

                            <div className="table-mobile-card-header-main">
                                <Link to={`/upselling/edit/${uniqid}`}>{title}</Link>
                                <div>{uniqid}</div>
                            </div>
                        </div>
                        <Actions showConfirm={() => showConfirm(item)} data={item} />
                    </div>


                    <div className="table-mobile-card-body">
                        <div className="table-mobile-card-body-list">
                            <div><div>Discount</div><div>{discount_type === "FIXED" ? `${config.CURRENCY_LIST[currency]}${Number(discount_amount).toFixed()}` : `${Number(discount_amount).toFixed()}%`}</div></div>
                            <div><div>Products</div><div>{(products || '').split(',').length}</div></div>
                        </div>
                    </div>

                </div>
            })}

            <Pagination
                currentPage={currentPage}
                totalCount={data.length}
                pageSize={SIZE}
                onPageChange={setCurrentPage}
            />

        </div>
    );
};

export default MobileProducts;
